<template>
    <div>
        <slot v-if="network"
              :network="network"
              :upsells="upsells"
              :selectedUpsell="selectedUpsell"
              :select="select"
              :isSingle="isSingle"
              :isSingleFree="isSingleFree"
        />
    </div>
</template>

<script>
export default {
    name: 'NetworkUpsell',

    data() {
        return {
            network: null,
            upsells: [],
            selectedUpsell: null,
        };
    },

    computed: {
        isSingle() {
            return this.upsells.length === 1;
        },
        isSingleFree() {
            return this.isSingle && this.selectedUpsell.isFree;
        }
    },

    methods: {
        install(data) {
            this.network = data.network;
            this.upsells = data.upsells;
            this.select(0);
        },

        select(index) {
            this.selectedUpsell = this.upsells[index] || null;
        }
    }
}
</script>
